var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #b79d78;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,.5L10.3,20.4v23.2c0,10.1,2.1,19.4,6.1,27.5,3.3,6.5,7.8,12.2,13.4,17.1,9.6,8.2,19.1,11,19.5,11.1l.7.2.7-.2c.4-.1,9.9-2.9,19.5-11.1,5.7-4.9,10.2-10.6,13.4-17.1,4.1-8.1,6.1-17.4,6.1-27.5v-23.2L50,.5ZM44.7,73.2l-19.3-19.3,7.1-7.1,12.3,12.3,28.5-32.3,7.1,7.1-35.6,39.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.c533ba80d9ae609e433c5985a8fa5259.svg";
export { ForwardRef as ReactComponent };